import PropTypes from 'prop-types';
import React from 'react';
import SocialLink from './SocialLink';

const CommunityBlock = ({data}) => {
    const {title, pattern, socialLinks=[]} = data;
    return (
        <section className="community-block" style={{backgroundImage: `url(${pattern})`}}>
            <div className="container-fluid section">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <h2>{title}</h2>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <div className="socialLink-container">
                            {socialLinks.map((item) => {
                            return (<SocialLink key={item.key} link={item} />)
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
CommunityBlock.propTypes = {
    data: PropTypes.object
}

export default CommunityBlock;
